// extracted by css-extract-rspack-plugin
export default {"modal":"paJ0eqQCIjIO_W8G"};